export enum AccessErrorTypes {
	SET_ACCESS_ERROR = "@accessError/SET_ACCESS_ERROR",
	CLEAR_ACCESS_ERROR = "@accessError/CLEAR_ACCESS_ERROR",
}

export interface AccessErrorState {
	hasAccessError: boolean;
}

export interface SetAccessError {
	type: typeof AccessErrorTypes.SET_ACCESS_ERROR;
	payload: {
		hasAccessError: boolean;
	};
}

export interface ClearAccessError {
	type: typeof AccessErrorTypes.CLEAR_ACCESS_ERROR;
}

export type AccessErrorActionTypes = SetAccessError | ClearAccessError;
